// import { formatDate } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import * as Countries from '@json/countries.json';
import { User } from '@models/user.model';
import { ApiService } from '@services/api/api.service';
import { LeadsService } from '@services/api/leads.service';
import { ListingPropertiesService } from '@services/api/listing-properties.service';
import { ProjectService } from '@services/api/project.service';
import { SettingService } from '@services/api/setting.service';
import { SharedService } from '@services/api/shared.service';
import { UserService } from '@services/api/user.service';
import { Utils } from '@services/helpers/utils';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { ActivityTrackerService } from '@services/user-activity/activity-tracker.service';
import { ReduxService } from '@state-management/redux.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { Leads } from '../leads/leads';
import moment from 'moment';
import { Crypto } from '@services/helpers/encryption-utils';
import { LocalStorageService } from '@services/helpers/local-storage.service';
import { DuplicateContactDraft } from '@modules/contact/possible-duplicate-contact/possible-duplicate-contact.component';
import { isNonAuPostcode, normalisePostcode, POSTCODE_MAX_LENGTH } from '@services/helpers/postcode.util';
import { RemmiConfirmService } from '@common/remmi-confirm/remmi-confirm.service';

@Component({
  selector: 'app-add-leads',
  templateUrl: './add-leads.component.html',
  styleUrls: ['./add-leads.component.scss'],
})
export class AddLeadsComponent {
  @Output() isSavedClosed = new EventEmitter<any>();
  @Input() propertyUpdate: Observable<any> = null;
  readonly postcodeMaxLength = POSTCODE_MAX_LENGTH;
  readonly isNonAuPostcode = isNonAuPostcode;
  @Input() newContactCreated: Observable<any> = null;
  @Input() addDefaultFields: any = {};
  /** When true, Close emits directly without Lead tab navigation (e.g. email inbox popup). */
  @Input() embedded = false;

  /** The single lot option behind the read-only Residential Project Lot field; empty hides it. */
  residentialLotOptions: any[] = [];

  options = { componentRestrictions: { country: 'AU' }, types: ['geocode'] };
  leadForm: FormGroup;
  countries = Countries['default']['data'];
  lead_category: any[] = [
    { name: 'Listing', value: 'listing' },
    { name: 'Project', value: 'project' },
    { name: 'Property', value: 'property' },
    { name: 'Client Requirements', value: 'requirement' },
  ];
  current_purpose: any[] = [];
  tenancy_details: any[] = [];
  reason_for_selling: any[] = [];
  reason_for_buying: any[] = [];
  bedrooms = Leads.beds;
  budgetList = [];
  bathrooms = Leads.bathrooms;
  land_size = Leads.land_size;
  marketPricing = Leads.marketPricing;
  unAssign = null;
  existingContactId = null;
  existingCompanyId = null;
  existingPrimaryContactId = null;
  /** Set while the "create new contact" side panel (opened from the Agent/Existing Clients
   * dropdown) is open, so the contact it creates gets auto-selected back into that dropdown. */
  awaitingNewContact: boolean = false;
  awaitingNewBuyer: boolean = false;
  buyerInfo: any = null;
  buyerSelectedIds = null;
  isFieldDisabled: boolean = false;
  /** Toggles the Buyer Details block on Agent leads. */
  currently_marketed: any = [{ tag_name: 'No' }, { tag_name: 'Yes' }];
  create_element: any;
  created_element_id: any;
  leadInsertedId: any;
  saveBtnDisable: boolean = false;
  contactInfo: any;
  companyInfo: any;
  dropDown = true;
  staff_user;
  activeStaffUser: any[] = [];
  isOwnerTeam: boolean = true;
  isAgentResponsibleTeam: boolean = true;
  teamList: any[] = [];
  all_property: any[] = [];
  all_listing: any[] = [];
  developmentType;
  projectStatus;
  lead_Status: any[] = [];
  lead_Source: any[] = [];
  enquiry_Type: any[] = [];
  lead_Type: any[] = [];
  property_Type: any[] = [];
  intended_use: any[] = [];
  time_frame: any[] = [];
  indoor_feature: any[] = [];
  outdoor_feature: any[] = [];
  Established_property: any[] = [];
  tagsList: any = [];
  companyRole: any[] = [];
  typeName: any;
  leadDetail: any;
  minDate = new Date();
  timer_options = Leads.timer_options;
  personalBriefTime = null;
  onsiteTrainingTime = null;

  constructor(
    private Api: ApiService,
    private toaster: ToastrService,
    private leads: LeadsService,
    private userService: UserService,
    private sharedService: SharedService,
    private listingService: ListingPropertiesService,
    public lmService: LeadManagementService,
    private fb: FormBuilder,
    public projectService: ProjectService,
    private redux: ReduxService,
    private localStorageService: LocalStorageService,
    private hostEl: ElementRef,
    private _settingService: SettingService,
    private activityTracker: ActivityTrackerService,
    private remmiConfirm: RemmiConfirmService
  ) {
    this.leadForm = this.fb.group({
      first_name: null,
      sub_office_id: null,
      last_name: null,
      mobile_phone: null,
      position: null,
      wechat: null,
      telephone: null,
      email: [null, [Validators.email]],
      suburb: null,
      postcode: null,
      countryregion: null,
      listing_project: null,
      project: null,
      apartment: null,
      listing_type: null,
      intended_use: null,
      time_frame: null,
      value: null,
      price_range: null,
      beds: null,
      baths: null,
      bathOption: null,
      car: null,
      pools: null,
      spa: null,
      land_area: null,
      min_land_area: null,
      max_land_area: null,
      internal_size: null,
      external_area: null,
      agent_responsible: null,
      Owner: null,
      time: new Date(),
      created_at: null,
      lead_source: null,
      enquiry_type: null,
      lead_status: null,
      not_interested: null,
      lead_type: null,
      listing: null,
      property: null,
      lead_category: null,
      established_property: null,
      features: null,
      indoor_feature: null,
      outdoor_feature: null,
      lead_status_log: null,
      address: null,
      tenancy_details: null,
      current_purpose: null,
      tenancy_end_date: null,
      reason_for_selling: null,
      reason_for_buying: null,
      company: null,
      development_type: null,
      project_address: [''],
      project_suburb: [''],
      project_status: null,
      // The lot the listing this lead came from is; shown read-only, never picked here.
      lot_id: [null],
      lot_quantity: [''],
      current_market: [null],
      product_mix: [''],
      levels: [''],
      amenities: [''],
      // not use
      lead_notes: null,
      full_name: null,
      contactid: null,
      agencyid: null,
      study: null,
      contact_method: null,
      nobedroom: null,
      attendee: [false],
      like_dislike: [null],

      // lead Information
      project_information_sent: null,
      project_information_sent_date: null,
      agreement_sent_date: null,
      agreement: null,
      personal_briefing_date: null,
      personal_briefing_time: null,
      personal_briefing_complete: null,
      onsite_training_date: null,
      onsite_training_time: null,
      onsite_training_complete: null,
      comments: null,

      // Agency details (Agent lead type)
      agency_name: null,
      agency_mobile_number: null,
      agency_website: null,
      agency_email: [null],

      // buyer details (Agent lead type) — the buyer is its own contact, separate from the agent in contactid
      buyer_detail_exist: false,
      buyer_contactid: null,

      // buyer details (Agent lead type)
      alternate_first_name: null,
      alternat_last_name: null,
      alternate_mobile: null,
      alternate_email: null,
    });
  }

  // Lifecycle hook that runs when the component is initialized
  ngOnInit(): void {
    // Patches the form with initial values
    this.leadForm.patchValue({
      countryregion: 'Australia', // Set default country region to Australia
      lead_category: 'requirement', // Set default lead category to 'requirement'
      created_at: new Date(), // Set the current date as the created date
    });

    // Default lead_type from the logged-in user: 'Agent' for johnny@ypmavanti.com.au, otherwise 'Buyer'
    this.setLeadTypeByLoggedInUser();

    // Subscribes to the propertyUpdate observable and retrieves updated property information
    this.propertyUpdate?.subscribe({
      next: response => {
        if (response) {
          this.created_element_id = response; // Assign the updated property ID
          this.getProperty(); // Retrieve the property details
        }
      },
    });

    // Auto-select the contact created via the Agent/Existing Clients dropdown's "create new"
    // flow. Only the instance that opened it has awaitingNewContact set, so other open Lead
    // tabs ignore this (there's only ever one "new contact" tab at a time). Left true (not
    // one-shot) so every save-ish action in that panel (Save, Save & Close, Associate Company)
    // re-syncs the dropdown/lead fields with the latest contact info — the panel only ever
    // emits for the contact it was opened for, so re-consuming is safe.
    this.newContactCreated?.subscribe({
      next: contactId => {
        if (this.awaitingNewBuyer && contactId) {
          this.onBuyerSelect({ _id: contactId });
        } else if (this.awaitingNewContact && contactId) {
          this.onUpdateSelect('contact', { _id: contactId });
        }
      },
    });

    // Fetches various data for the component
    this.lmService.getPropertyFeatures(); // Retrieves property features
    this.getLeadTags(); // Retrieves lead tags
    this.getCompanyRoleTags(); // Retrieves company-role tags (for Position dropdown)
    this.getStaffUsers(); // Retrieves staff users
    this.getTeamList();
    this.getSubOffices();
    this.lmService.GetProjectList(); // Retrieves project list
    this.getListing(); // Retrieves listing data
    this.getProperty(); // Retrieves property details

    // Sets a timeout to patch form values after 3 seconds
    setTimeout(() => {
      this.patchFormValue(); // Update form values after 3 seconds
    }, 3000);
  }

  // Fetches and stores logged-in user details

  /** Set lead_type based on the logged-in user's email: 'Agent' for johnny@ypmavanti.com.au, else 'Buyer'. */
  setLeadTypeByLoggedInUser() {
    this.redux.getUser().subscribe({
      next: response => {
        const email: string = response?.data?.email?.toLowerCase()?.trim();
        this.leadForm.patchValue({
          lead_type: email === 'johnny@ypmavanti.com.au' ? 'Agent' : 'Buyer',
        });
      },
    });
  }

  subOfficeList: any[] = [];
  getSubOffices() {
    this._settingService.getSubOfficeList().subscribe({
      next: (response: any) => {
        this.subOfficeList = response?.data || [];
        this.applyDefaultSubOffice();
      },
    });
  }

  // Defaults the Sub Office field to the first option, same as the other office pickers.
  applyDefaultSubOffice() {
    if (!this._settingService.isSubOfficeAutoDefaultEnabled()) {
      return;
    }
    if (this.subOfficeList.length && !this.leadForm.get('sub_office_id')?.value) {
      this.leadForm.get('sub_office_id')?.setValue(this.subOfficeList[0]._id);
    }
  }

  checkValidation(value) {
    if (value) {
      return /[a-zA-Z]/.test(value) ? true : false;
    }
  }

  // Function to patch form values based on the type of lead creation (contact, project, listing, or default)
  patchFormValue() {
    // Check if the lead type is 'contact'
    if (this.addDefaultFields?.lead_create === 'contact') {
      // Disable fields if the lead type is 'contact'
      this.isFieldDisabled = true;
      // Set the contact ID from the provided default fields
      this.existingContactId = this.addDefaultFields?.contactid;

      // Patch form with the contact-related fields
      this.leadForm.patchValue(this.addDefaultFields);

      // Additional form values for 'contact' type
      this.leadForm.patchValue({
        mobile_phone: this.addDefaultFields?.mobile_phone, // Set mobile phone from the default fields
        countryregion: 'Australia', // Set default country region to Australia
        lead_category: 'requirement', // Set lead category to 'requirement'
        contactid: this.addDefaultFields?.contactid, // Set contact ID
        created_at: new Date(), // Set the current date as created date
      });

      // Check if the lead type is 'project'
    } else if (this.addDefaultFields?.lead_create === 'project') {
      // Patch form with the project-related fields
      this.leadForm.patchValue({
        agent_responsible: this.Api.getUserId(), // Set the agent responsible from the API
        Owner: null, // Set the owner as the current user
        project: this.addDefaultFields?.project, // Set the project from the default fields
        countryregion: 'Australia', // Set default country region to Australia
        lead_category: 'project', // Set lead category to 'project'
        created_at: new Date(), // Set the current date as created date
      });

      // A lead raised from a listing that is a lot carries that lot. It is shown rather than
      // picked, so the one option is built here instead of loading the project's whole lot list.
      const lotId = this.addDefaultFields?.residential_project_lot;
      if (lotId) {
        this.residentialLotOptions = [{ _id: lotId, lot_name: this.addDefaultFields?.residential_project_lot_name || lotId }];
        this.leadForm.patchValue({ lot_id: lotId });
      }

      this.getProjectDetails();

      // Check if the lead type is 'listing'
    } else if (this.addDefaultFields?.lead_create === 'listing') {
      // Patch form with the listing-related fields
      this.leadForm.patchValue({
        countryregion: 'Australia', // Set default country region to Australia
        lead_category: 'listing', // Set lead category to 'listing'
        created_at: new Date(), // Set the current date as created date
        agent_responsible: this.addDefaultFields?.agent_responsible, // Set agent responsible from the default fields
        Owner: null, // Set owner from the agent responsible
        listing: this.addDefaultFields?.listing, // Set listing ID from the default fields
        beds: this.addDefaultFields?.beds, // Set number of beds from the default fields
        baths: this.addDefaultFields?.baths, // Set number of baths from the default fields
        pools: this.addDefaultFields?.pools, // Set number of pools from the default fields
        value: this.addDefaultFields?.value, // Set the value of the property from the default fields
        external_area: this.addDefaultFields?.land_area, // Set land area from the default fields
        internal_size: this.addDefaultFields?.building_area, // Set building area from the default fields
      });

      // Default case if none of the specific lead types match
    } else {
      // Patch form with default values
      let officeName = Crypto.decrypt(this.localStorageService.GetItem('office_name'));

      this.leadForm.patchValue({
        agent_responsible: this.Api.getUserId(), // Set the agent responsible from the API
        Owner: null, // Set the owner as the current user
        lead_status: null, // Set lead status to 'New'
        countryregion: 'Australia', // Set default country region to Australia
        lead_category: 'requirement', // Set lead category to 'requirement'
        created_at: new Date(), // Set the current date as created date
        established_property: officeName == 'YPM Avanti' ? 'New' : null,
        ...(this.addDefaultFields?.email ? { email: this.addDefaultFields.email } : {}),
      });
    }
  }

  // Function to initiate a phone call using the phone number passed as an argument
  dialCall(number) {
    // Use the 'tel:' protocol to initiate a phone call with the provided phone number
    this.activityTracker.trackOnCurrentRecord('call');
    window.location.href = 'tel:' + number;
  }

  // Function to fetch lead tags and allocate them to specific fields
  getLeadTags() {
    // Call the 'getTags' method from the redux service to fetch tags for 'lead'
    this.redux.getTags(this.Api.getOfficeId(), true, 'lead').subscribe({
      next: response => {
        // Destructure the response to get the status and data
        const { status, data } = response;

        // If the request is successful
        if (status) {
          // Assign the fetched tags to 'tagsList'
          this.tagsList = data;

          // Allocate tags to various fields
          this.allocateTagsToFields('lead-type');
          this.allocateTagsToFields('lead-source');
          this.allocateTagsToFields('property-type');
          this.allocateTagsToFields('lead-status');
          this.allocateTagsToFields('new-or-established-property');
          this.allocateTagsToFields('current-purpose');
          this.allocateTagsToFields('tenancy-detail');
          this.allocateTagsToFields('reason-for-buying');
          this.allocateTagsToFields('reason-for-selling');
          this.allocateTagsToFields('timeframe');
          this.allocateTagsToFields('price-range');
          this.allocateTagsToFields('intended-use');
          this.allocateTagsToFields('outdoor-feature');
          this.allocateTagsToFields('indoor-feature');
          this.allocateTagsToFields('development-type');
          this.allocateTagsToFields('project-status');
          this.allocateTagsToFields('lead-status-no-further-interest');
          this.allocateTagsToFields('agreement');
          this.allocateTagsToFields('enquiry-type');
        } else {
          // If the request fails, reset the tags list
          this.tagsList = [];
        }
      },
      error: () => {
        // In case of an error, reset the tags list
        this.tagsList = [];
      },
    });
  }

  // Fetch 'company-role' tags from the contact module to populate the Position dropdown
  getCompanyRoleTags() {
    this.redux.getTags(this.Api.getOfficeId(), true, 'contact').subscribe({
      next: res => {
        const data = res?.data || [];
        const allTypes = data.flatMap(mod => mod?.types || []);
        const found = allTypes.find(tag => tag?.slug?.toLowerCase() === 'company-role');
        this.companyRole = found?.data ? [...found.data].sort((a, b) => a?.tag_name?.localeCompare(b?.tag_name)) : [];
      },
      error: () => {
        this.companyRole = [];
      },
    });
  }

  not_interested_reason: any = [];
  agreementList: any = [];

  // Function to allocate tags to various fields based on the 'choice' parameter
  allocateTagsToFields(
    choice:
      | 'project-status'
      | 'development-type'
      | 'new-or-established-property'
      | 'current-purpose'
      | 'tenancy-detail'
      | 'reason-for-buying'
      | 'reason-for-selling'
      | 'timeframe'
      | 'price-range'
      | 'intended-use'
      | 'outdoor-feature'
      | 'indoor-feature'
      | 'lead-status'
      | 'lead-status-no-further-interest'
      | 'lead-source'
      | 'enquiry-type'
      | 'lead-type'
      | 'agreement'
      | 'property-type' = null
  ) {
    // Initialize availableTags with data from tagsList (first object, types property)
    let removeT: any[] = this.tagsList?.[0]?.types || [];
    let availableTags: any[] = removeT.map(ele => {
      return { ...ele, slug: ele?.slug?.toLowerCase()?.includes('\t') ? ele?.slug?.toLowerCase().replace('\t', '') : ele?.slug };
    });
    // Switch case to handle different 'choice' values and assign corresponding tags to the fields
    switch (choice) {
      case 'lead-status': {
        // Prefer a lead-type-specific status list (e.g. 'agent-lead-status') if one exists, otherwise fall back to the generic list
        let lead_type_slug: string =
          this.lead_Type?.find(local_tag => local_tag?.tag_name?.toLowerCase() === this.leadForm.controls?.[`lead_type`]?.value?.toLowerCase())
            ?.tag_slug || '';
        let foundedData =
          (lead_type_slug && availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === `${lead_type_slug}-lead-status`?.toLowerCase())) ||
          availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.lead_Status =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_order > b?.tag_order ? 1 : -1)) : null;
        break;
      }
      case 'agreement': {
        // Fixed order (not tag_order/tag_name) — matches the agreement lifecycle: sent, returned signed, then executed copy sent back
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        let order = ['Agreement Sent', 'Signed Agreement Returned', 'Executed Agreement Sent'];
        this.agreementList =
          foundedData && Object.keys(foundedData)?.length > 0
            ? [...foundedData?.data]?.sort((a, b) => order.indexOf(a?.tag_name) - order.indexOf(b?.tag_name))
            : null;
        break;
      }
      case 'lead-status-no-further-interest': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.not_interested_reason =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_order > b?.tag_order ? 1 : -1)) : null;
        break;
      }
      case 'enquiry-type': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.enquiry_Type =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data].sort((a, b) => a?.tag_name.localeCompare(b?.tag_name)) : null;
        break;
      }
      case 'lead-source': {
        // Check if the typeName is 'prospective-seller', otherwise handle normally
        if (this.typeName === 'prospective-seller') {
          let lead_type_slug: string =
            this.lead_Type?.find(local_tag => local_tag?.tag_name?.toLowerCase() === this.leadForm.controls?.[`lead_type`]?.value?.toLowerCase())
              ?.tag_slug || '';
          let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === `${lead_type_slug}-lead-source`?.toLowerCase());
          if (foundedData) {
            // If data is found, sort by tag_name
            this.lead_Source =
              foundedData && Object.keys(foundedData)?.length > 0
                ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1))
                : null;
          }
        } else {
          // Otherwise, directly find the data based on the 'choice' and sort it
          let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
          this.lead_Source =
            foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        }
        break;
      }
      case 'lead-type': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.lead_Type =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        break;
      }
      case 'property-type': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.property_Type =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        break;
      }
      case 'current-purpose': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.current_purpose =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        break;
      }
      case 'tenancy-detail': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.tenancy_details =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        break;
      }
      case 'reason-for-buying': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.reason_for_buying =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        break;
      }
      case 'reason-for-selling': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.reason_for_selling =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        break;
      }
      case 'timeframe': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.time_frame =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        break;
      }

      case 'price-range': {
        // Find the data based on the 'choice' and sort by the price-range display order
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.budgetList = foundedData && Object.keys(foundedData)?.length > 0 ? Leads.sortPriceRange(foundedData?.data) : null;
        break;
      }

      case 'intended-use': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.intended_use =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        break;
      }

      case 'outdoor-feature': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.outdoor_feature =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        break;
      }
      case 'indoor-feature': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.indoor_feature =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        break;
      }

      case 'development-type': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.developmentType =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        break;
      }
      case 'project-status': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.projectStatus =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        break;
      }
      case 'new-or-established-property': {
        // Find the data based on the 'choice' and sort by tag_name
        let foundedData = availableTags?.find(local_tag => local_tag?.slug?.toLowerCase() === choice?.toLowerCase());
        this.Established_property =
          foundedData && Object.keys(foundedData)?.length > 0 ? [...foundedData?.data]?.sort((a, b) => (a?.tag_name > b?.tag_name ? 1 : -1)) : null;
        break;
      }
      default:
        break; // No action if no matching case
    }
  }

  manageLeadStatus(onLoadPatchForm: boolean = false) {
    // If onLoadPatchForm is true, we perform additional operations related to lead status logs
    if (onLoadPatchForm) {
      let logs: any[] = this.leadForm.controls?.[`lead_status_log`].value || [];

      // If there are no logs, clean up lead status by removing 'changed_on' property if it exists
      if (logs?.length === 0) {
        this.lead_Status = this.lead_Status?.map(result => {
          if (result?.hasOwnProperty('changed_on')) {
            delete result?.[`changed_on`]; // Remove 'changed_on' if present
          }
          return result;
        });
      } else {
        // If logs are present, update lead status with the 'changed_on' date from logs
        this.lead_Status = this.lead_Status
          ?.map(result => {
            let foundedIndex: number = logs?.findIndex(local_tag => local_tag?.tag_name === result?.tag_name);

            // If the tag name exists in logs, update it with the 'changed_on' value
            if (foundedIndex > -1) {
              result = { ...result, changed_on: logs?.[foundedIndex]?.changed_on };
            }
            return result;
          })
          // Sort the updated lead status based on tag_order
          ?.sort((a, b) => (a?.tag_order > b?.tag_order ? 1 : -1));
      }
    } else {
      // If onLoadPatchForm is false, perform logic for handling lead status changes
      let local_lead_type = this.leadForm.controls?.[`lead_type`].value;

      // If no lead type is selected, clear the lead_status_log field
      if (!local_lead_type) {
        this.leadForm.patchValue({
          lead_status_log: null,
        });
      } else {
        let original_value = this.leadForm.controls?.[`lead_status`].value;
        let cloned_value = this.leadForm?.[`lead_status`];

        // If the original and cloned values of lead_status are different, update the lead status and logs
        if (original_value !== cloned_value) {
          this.lead_Status = this.lead_Status
            ?.map(result => {
              // If the result matches the original value, update it with 'changed_on' date
              if (result?.tag_name === original_value) {
                result = { ...result, changed_on: new Date() };

                let logs: any[] = this.leadForm.controls?.[`lead_status_log`].value || [];
                let foundedIndex = logs.findIndex(local_log => local_log?.tag_name === original_value);

                // If the original value exists in the logs, update it; otherwise, push it to the logs
                if (foundedIndex > -1) {
                  logs[foundedIndex] = result;
                } else {
                  logs?.push(result);
                  this.leadForm.patchValue({
                    lead_status_log: logs,
                  });
                }
              }
              return result;
            })
            // Sort the updated lead status based on tag_order
            ?.sort((a, b) => (a?.tag_order > b?.tag_order ? 1 : -1));
        }
      }
    }
  }

  getListing() {
    // Check if office ID is available from the API
    if (this.Api.getOfficeId()) {
      // Fetch short listing data from the API
      this.listingService.getShortListing(false, true, true, false, false).subscribe({
        next: response => {
          // Reset and assign the response data to the all_listing property
          this.all_listing = [];
          this.all_listing = response?.data;
        },
      });
    }
  }

  getProperty() {
    // Fetch property dropdown items from the shared service
    this.sharedService.getDropDownItems('property').subscribe({
      next: response => {
        // Reset and assign the response data to the all_property property
        this.all_property = [];
        this.all_property = response?.data;

        // Find the specific property element that matches the created_element_id
        let property_ele = this.all_property?.filter(ele => ele?._id === this.created_element_id);

        // If the property element exists, patch the form with property details
        if (property_ele) {
          this.leadForm.patchValue({
            property: property_ele[0]?._id,
            beds: property_ele[0]?.beds,
            baths: property_ele[0]?.baths,
            value: property_ele[0]?.value,
            listing_type: property_ele[0]?.type,
            car: property_ele[0]?.car_park_no,
            pool: property_ele[0]?.pool,
            internal_size: property_ele[0]?.building_area,
            external_area: property_ele[0]?.land_area,
          });
        }
      },
    });
  }

  formatTimeTo12Hour(time: Date): string {
    // If the time is not provided, return an empty string
    if (!time) return '';

    // Extract hours and minutes from the provided time
    let hours = time.getHours();
    const minutes = time.getMinutes();

    // Determine whether it's AM or PM
    const am_pm = hours >= 12 ? ' pm' : ' am';

    // Convert 24-hour time to 12-hour time
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Format minutes to always show two digits
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;

    // Construct the formatted time string
    const formattedTime = hours + ':' + minutesStr + am_pm;

    // Return the formatted time string
    return formattedTime;
  }

  getStaffUsers() {
    // Construct the URL for fetching office staff users based on user ID and office ID
    let url = `/users/office-staff-list?uid=${this.Api.getUserId()}&officeid=${this.Api.getOfficeId()}&show=staff`;

    // Fetch staff user data using the URL and update the staff_user property
    this.redux.getSetProjectInfo(false, 'office_staff', url).subscribe({
      next: response => {
        const { status, data } = response;

        // If the status is true, sort the staff users by their full name and assign to staff_user
        if (status) {
          this.staff_user = JSON.parse(JSON.stringify(data)).sort((a, b) => a?.full_name.localeCompare(b?.full_name)) as User[];
          this.activeStaffUser = this.staff_user;
        } else {
          // If the status is false, assign an empty array to staff_user
          this.staff_user = [];
          this.activeStaffUser = [];
        }
      },
    });
  }

  getTeamList() {
    this.sharedService.getDropDownItems('teams').subscribe({
      next: response => {
        this.teamList =
          response?.data?.map(team => {
            return { ...team, full_name: team?.name };
          }) || [];
        console.log('team list', this.teamList);
      },
    });
  }

  handleAddressChange(event, type) {
    if (type === 'project_address') {
      this.leadForm.patchValue({
        project_address: event?.formatted_address,
      });
    } else {
      this.leadForm.patchValue({
        address: event?.formatted_address,
      });
    }
    // Loop through the address components to find the "locality" type
    event?.address_components.forEach(el => {
      el.types.forEach(type => {
        // If the type is "locality", patch the value of project_suburb in the form
        if (type === 'locality') {
          this.leadForm.patchValue({
            project_suburb: el?.long_name,
          });
        }
      });
    });
  }

  getProjectDetails() {
    let projectId = this.leadForm.controls['project'].value;
    this.projectService.getProjectShortDetails(projectId).subscribe({
      next: response => {
        this.leadForm.patchValue({
          Owner: response?.data?.team_id || null,
        });
      },
    });
  }

  getListingValue(element) {
    // Update the form with the properties of the provided element
    this.leadForm.patchValue({
      beds: element?.beds,
      baths: element?.baths,
      value: element?.value,
      listing_type: element?.type,
      car: element?.car_park_no,
      pool: element?.pool,
      internal_size: element?.building_area,
      external_area: element?.land_area,
    });
  }

  resetFieldOnChange() {
    // Reset multiple fields in the form to null
    this.leadForm.patchValue({
      project: null,
      apartment: null,
      intended_use: null,
      time_frame: null,
      value: null,
      beds: null,
      baths: null,
      car: null,
      pool: null,
      spa: null,
      land_area: null,
      internal_size: null,
      external_area: null,
      listing: null,
      listing_type: null,
    });
  }

  openPopup(ele) {
    console.log('log', ele);

    // If the element is 'contact', show the 'edit_contact' tab with the contact's info
    if (ele === 'contact') {
      this.lmService.isEdit_show_div = 'edit_contact';
      this.lmService.addTabInLevels(
        `Contact - ${this.leadDetail?.name}`,
        this.leadDetail?._id,
        this.leadDetail || this.contactInfo?.name,
        this.contactInfo?._id,
        'contact'
      );
    } else {
      // Otherwise, show the 'add_property' tab
      this.lmService.property_show_div = 'add_property';
      this.lmService.addTabInLevels('Property', 'createnew');
    }
  }

  assignLead(lead) {
    // Call the API to assign the lead with the provided ID and other details
    let formData = lead;
    formData['lead_category'] = 'listing';
    formData['listing'] = this.addDefaultFields.listing;
    console.log(formData);
    this.leads.updateLead(lead?._id, formData).subscribe({
      next: _ => {
        // Emit the result of saving/closing the lead and display a success message
        this.isSavedClosed.emit({ isClose: false, lead: null });
        this.toaster.success('Lead assigned successfully');
      },
    });
  }

  closeLead() {
    if (this.embedded) {
      this.emitLeadClosed();
      return;
    }
    let tab = this.lmService.tab_levels.find(el => el.name == 'Lead' && el.data == null);
    // If such a tab exists, find its index and emit a close action
    if (tab) {
      let index = this.lmService.tab_levels.indexOf(tab);
      this.isSavedClosed.emit({ level: tab, index: index, isClose: true, lead: this.leadInsertedId });
    }
  }

  private emitLeadClosed(): void {
    this.isSavedClosed.emit({ isClose: true, lead: this.leadInsertedId ?? null });
  }

  removeLevelTab() {
    // Find the 'Lead' tab in the tab_levels array
    let tab = this.lmService.tab_levels.find(el => el.name == 'Lead');

    // If the tab is found, update its taskTabs property and emit the close action
    if (tab) {
      tab['taskTabs'] = true;
      this.isSavedClosed.emit({ isClose: true, lead: null });
    } else {
      // If no tab is found, emit the close action directly
      this.isSavedClosed.emit(true);
    }
  }

  addCustomProject(tag) {
    // If a tag is provided, return an object representing a custom project with the tag
    if (tag) {
      return { _id: tag, Project_Name: tag };
    }
  }

  selectDate() {
    // Retrieve the 'created_at' and 'tenancy_end_date' values from the form
    let created_at = this.leadForm.controls['created_at'].value;
    let tenancy_end_date = this.leadForm.controls['tenancy_end_date'].value;
    let agreement_sent_date = this.leadForm.controls['agreement_sent_date'].value;
    let project_information_sent_date = this.leadForm.controls['project_information_sent_date'].value;
    let personal_briefing_date = this.leadForm.controls['personal_briefing_date'].value;
    let onsite_training_date = this.leadForm.controls['onsite_training_date'].value;

    let val1 = null;
    let val2 = null;
    let val3 = null;
    let val4 = null;
    let val5 = null;
    let val6 = null;

    // If the 'created_at' value exists, format it using the Utils.getDateStringFormat function
    if (created_at) {
      val1 = Utils.getDateStringFormat(new Date(created_at));
    } else {
      val1 = Utils.getDateStringFormat(new Date());
    }

    // If the 'tenancy_end_date' value exists, format it using the Utils.getDateStringFormat function
    if (tenancy_end_date) {
      val2 = Utils.getDateStringFormat(new Date(tenancy_end_date));
    }
    if (agreement_sent_date) {
      val3 = Utils.getDateStringFormat(new Date(agreement_sent_date));
    }
    if (project_information_sent_date) {
      val4 = Utils.getDateStringFormat(new Date(project_information_sent_date));
    }
    if (personal_briefing_date) {
      val5 = Utils.getDateStringFormat(new Date(personal_briefing_date));
    }
    if (onsite_training_date) {
      val6 = Utils.getDateStringFormat(new Date(onsite_training_date));
    }
    // Update the form values for 'created_at' and 'tenancy_end_date' with the formatted dates
    this.leadForm.patchValue({
      created_at: new Date(val1),
      tenancy_end_date: val2 ? new Date(val2) : null,
      agreement_sent_date: val3 ? new Date(val3) : null,
      project_information_sent_date: val4 ? new Date(val4) : null,
      personal_briefing_date: val5 ? new Date(val5) : null,
      onsite_training_date: val6 ? new Date(val6) : null,
    });
  }

  openRightModal(event) {
    console.log('event :>> ', event);
    this.awaitingNewContact = true;
    this.awaitingNewBuyer = false;
    this.lmService.contact_show_div = 'add_contact';
    this.lmService.addTabInLevels('Contact', 'new', null, {}, 'contact');
  }

  // Only one "new contact" panel is open at a time, so the buyer flow takes over the
  // newContactCreated stream from the agent flow until the agent's Create New is used again.
  openBuyerRightModal(): void {
    this.awaitingNewBuyer = true;
    this.awaitingNewContact = false;
    this.lmService.contact_show_div = 'add_contact';
    this.lmService.addTabInLevels('Contact', 'new', null, {}, 'contact');
  }

  onBuyerSelect(event: any): void {
    if (!event?._id) {
      this.clearBuyer();
      return;
    }
    if (event._id === this.leadForm.controls['contactid'].value) {
      this.toaster.error('The buyer must be a different contact from the agent');
      this.buyerSelectedIds = null;
      return;
    }
    this.userService.getContactUser(event._id).subscribe({
      next: response => {
        this.buyerInfo = response?.data;
        this.buyerSelectedIds = response?.data?._id;
        this.leadForm.patchValue({ buyer_contactid: response?.data?._id });
      },
    });
  }

  onBuyerToggle(event: any): void {
    if (event?.checked || !this.leadForm.controls['buyer_contactid'].value) {
      return;
    }
    // Keep the section open until the user confirms the buyer should come off the lead.
    this.leadForm.patchValue({ buyer_detail_exist: true });
    this.remmiConfirm
      .ask({
        title: 'Remove Buyer?',
        message: 'The buyer will be removed from this lead. The agent stays linked to the lead.',
        subject: this.buyerInfo?.full_name,
        confirmLabel: 'Remove Buyer',
        tone: 'danger',
      })
      .subscribe(isConfirmed => isConfirmed && this.confirmRemoveBuyer());
  }

  confirmRemoveBuyer(): void {
    this.clearBuyer();
    this.leadForm.patchValue({ buyer_detail_exist: false });
  }

  private clearBuyer(): void {
    this.buyerInfo = null;
    this.buyerSelectedIds = null;
    this.leadForm.patchValue({ buyer_contactid: null });
  }

  /** Buyer details only belong to Agent leads; a lead switched to another type drops them. */
  private applyBuyerFields(formData: any): void {
    if (formData['lead_type'] !== 'Agent' || !formData['buyer_detail_exist']) {
      formData['buyer_detail_exist'] = false;
      formData['buyer_contactid'] = null;
    }
  }

  onUpdateSelect(param, event: any) {
    console.log('event', event);
    if (param === 'contact') {
      // If the event is null, reset the fields and enable the form fields
      if (event === null) {
        this.isFieldDisabled = false;
        this.existingContactId = null;
        this.contactInfo = null;
        this.leadForm.patchValue({
          first_name: null,
          last_name: null,
          mobile_phone: null,
          telephone: null,
          email: null,
          suburb: null,
          postcode: null,
          contactid: null,
        });
      } else {
        // If the event is not null, disable the form fields and patch the form with the contact data
        this.isFieldDisabled = true;
        this.leadDetail = event;

        this.patchEditForm(event._id);
      }
    } else {
      console.log('company', event);
      if (event) {
        this.companyInfo = event;
        this.leadForm.patchValue({
          agencyid: event?._id,
        });
      } else {
        this.companyInfo = null;
        this.leadForm.patchValue({
          agencyid: null,
        });
      }
    }
  }

  patchEditForm(id) {
    this.userService.getContactUser(id).subscribe({
      next: response => {
        // Store the contact data and ID in the component's properties
        this.contactInfo = response?.data;
        this.existingContactId = response?.data?._id;
        this.existingCompanyId =
          response?.data?.companies_data?.length > 0 && response?.data?.companies_data[0]?.email ? response?.data?.companies_data[0]?._id : null;
        // Patch the form with the contact data
        this.leadForm.patchValue({
          contactid: response?.data?._id,
          first_name: response?.data?.first_name,
          last_name: response?.data?.last_name,
          full_name: response?.data?.full_name,
          mobile_phone: response?.data?.mobile_no,
          telephone: response?.data?.telephone || null,
          email: response?.data?.email,
          suburb: typeof response?.data?.suburb == 'object' ? response?.data?.suburb?.suburb : response?.data?.suburb,
          postcode: response?.data?.post_code,
        });
      },
    });
  }

  /**
   * Checks if a string is a valid email address.
   * @param email The string to validate.
   * @returns `true` if valid, `false` otherwise.
   */
  isEmailValid(email: string): boolean {
    if (!email) return false;

    // Basic email regex (covers most common cases)
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  public lead_status_type = null;

  changeLeadStatus(event) {
    console.log('eve >>:', event);
    !event?.is_active ? (this.lead_status_type = 'Inactive') : (this.lead_status_type = 'Active');
    this.autofillStatusDate(event?.tag_name);
  }

  // Lead Status -> the Lead Information date/time field(s) it stamps with the current date/time once that status is reached.
  // Agreement Executed has no corresponding field, so it intentionally stamps nothing here.
  private statusDateFieldMap: { [status: string]: { dateField: string; timeField?: string }[] } = {
    'Project Info Sent': [{ dateField: 'project_information_sent_date' }],
    'Agreement Sent': [{ dateField: 'agreement_sent_date' }],
    'Briefing Pending': [{ dateField: 'personal_briefing_date' }],
    'Briefing Completed': [{ dateField: 'personal_briefing_date' }, { dateField: 'onsite_training_date', timeField: 'onsite_training_time' }],
    'Trained and Engaged': [{ dateField: 'personal_briefing_date' }, { dateField: 'onsite_training_date', timeField: 'onsite_training_time' }],
  };

  autofillStatusDate(statusName: string) {
    if (!this.leadForm.controls['lead_type'].value?.includes('Agent')) return;
    const targets = this.statusDateFieldMap[statusName];
    if (!targets) return;
    const now = new Date();
    const patch: { [field: string]: any } = {};
    targets.forEach(({ dateField, timeField }) => {
      if (!this.leadForm.controls[dateField]?.value) patch[dateField] = now;
      if (timeField && !this.leadForm.controls[timeField]?.value) patch[timeField] = this.currentTimerSlot(now);
    });
    if (Object.keys(patch).length) this.leadForm.patchValue(patch);
  }

  // Rounds to the nearest slot in inspection_timer_options's format, e.g. '2pm' / '2:30pm'.
  private currentTimerSlot(now: Date): string {
    const hours = now.getHours();
    const roundedMinutes = now.getMinutes() < 30 ? 0 : 30;
    const period = hours >= 12 ? 'pm' : 'am';
    const hour12 = hours % 12 || 12;
    return roundedMinutes === 0 ? `${hour12}${period}` : `${hour12}:30${period}`;
  }

  combineDateAndTime(time: string, dateString: string): Date {
    const date = new Date(dateString);

    // Extract hours and minutes from time (e.g., "04:48 PM")
    const [timePart, modifier] = time.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);

    // Convert to 24-hour format
    if (modifier === 'pm' && hours !== 12) {
      hours += 12;
    }
    if (modifier === 'am' && hours === 12) {
      hours = 0;
    }

    // Set time to date
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date;
  }

  //   private buildEnquiryEmailContents() {

  //     const html =
  //       `Hi,

  // A new lead has been received for the YPM Test Project.

  //       Name: Abc
  //     Phone: <a href="tel:" >0400 000 000 </a>
  //     Email: <a href="mailto:abc@gmail.com" > abc@gmail.com</a>
  //     Responses:
  //     Last name: Xyz
  //     beds: 4
  //     price: 1000000
  //     timeframe: 1-3 months

  // If you have any questions, please contact us.`

  //     return { parsed: { html } };
  //   }

  saveLead(method) {
    if (this.saveBtnDisable) {
      return;
    }

    // If no lead has been inserted yet, create a new lead
    if (!this.leadInsertedId) {
      this.selectDate();

      // Disable the save button and manage the lead status
      this.manageLeadStatus(false);
      this.leadForm.patchValue({
        full_name: this.leadForm.controls['first_name'].value + ' ' + this.leadForm.controls['last_name'].value,
      });
      // Prepare the form data and add user ID and office ID
      let formData = this.leadForm.value;
      formData['personal_briefing_date'] = formData['personal_briefing_date']
        ? moment(formData['personal_briefing_date']).format('YYYY-MM-DD') + 'T' + formData['personal_briefing_time']
        : null;
      formData['onsite_training_date'] = formData['onsite_training_date']
        ? moment(formData['onsite_training_date']).format('YYYY-MM-DD') + 'T' + formData['onsite_training_time']
        : null;
      formData['agreement_sent_date'] = formData['agreement_sent_date'] ? moment(formData['agreement_sent_date']).format('YYYY-MM-DD') : null;
      formData['project_information_sent_date'] = formData['project_information_sent_date']
        ? moment(formData['project_information_sent_date']).format('YYYY-MM-DD')
        : null;

      const createdAt = moment(formData['created_at']);
      const time = moment(formData['time']);
      createdAt.set({
        hour: time.hour(),
        minute: time.minute(),
        second: time.second(),
      });

      formData['created_at'] = createdAt.toISOString();

      if (!this.isEmailValid(formData['email'])) {
        this.toaster.error('Please enter a valid email address');
        return;
      }

      this.saveBtnDisable = true;
      let tenancy_date = this.leadForm.controls['tenancy_end_date'].value;
      formData['user_id'] = this.Api.getUserId();
      formData['office_id'] = this.Api.getOfficeId();
      formData['postcode'] = normalisePostcode(formData['postcode']);
      formData['is_read'] = false;
      formData['status_type'] = !this.leadForm.controls['lead_status'].value ? 'Inactive' : this.lead_status_type;
      formData['tenancy_end_date'] = tenancy_date ? tenancy_date : null;
      formData['isOwnerTeam'] = this.isOwnerTeam;
      formData['isAgentResponsibleTeam'] = this.isAgentResponsibleTeam;
      this.applyBuyerFields(formData);

      delete formData['personal_briefing_time'];
      delete formData['onsite_training_time'];

      // Enquiry content for backend / Remmi AI correction (emailcontents.parsed.html)
      // formData['emailcontents'] = this.buildEnquiryEmailContents();

      this.leads.addNewLead(formData).subscribe({
        next: response => {
          // Show success message, enable the button, and reset fields
          this.toaster.success('Lead added successfully');
          this.saveBtnDisable = false;
          this.leadInsertedId = response?.data?.insertedId;
          this.isFieldDisabled = false;
          this.lmService.updateProjectSummary(true);

          // Emit close signal and reset fields if the method is not 'onlyCreate'
          if (method !== 'onlyCreate') {
            this.convertToContact(this.leadInsertedId);
            // this.leadForm.reset();
            this.existingContactId = null;
          } else {
            this.isSavedClosed.emit({ isClose: false, lead: null });
          }
        },
        error: error => {
          this.saveBtnDisable = false;
          const apiError = error?.error || error;
          if (apiError?.fields?.length) {
            this.invalidFields = apiError.fields;
            // Allow ngClass error styles to render before querying the DOM.
            this.focusInvalidFields(100);
          } else {
            this.invalidFields = [];
          }
          let errorArray = ['Not Interested  required', 'No Further Interest required'];
          let errorMessage = errorArray?.includes(error?.message) ? 'Please select a reason for no further interest before saving.' : error?.message;
          this.toaster.error(errorMessage);
        },
      });
    } else {
      // If a lead already exists, update the existing lead
      this.saveBtnDisable = true;
      this.selectDate();

      // Disable the save button and update the full name
      this.leadForm.patchValue({
        full_name: this.leadForm.controls['first_name'].value + ' ' + this.leadForm.controls['last_name'].value,
      });

      // Prepare the form data and set 'is_read' to false
      let formData = this.leadForm.value;
      formData['postcode'] = normalisePostcode(formData['postcode']);
      formData['is_read'] = false;
      formData['status_type'] = !this.leadForm.controls['lead_status'].value ? 'Inactive' : this.lead_status_type;
      this.applyBuyerFields(formData);

      // Call the service to update the lead
      this.leads.updateLead(this.leadInsertedId, formData).subscribe({
        next: response => {
          const { status } = response;
          if (status) {
            // Show success message, enable the button, and reset fields
            this.toaster.success('Lead updated successfully');
            this.saveBtnDisable = false;

            // Emit close signal and reset fields if the method is not 'onlyCreate'
            if (method !== 'onlyCreate') {
              if (this.embedded) {
                this.emitLeadClosed();
                this.leadForm.reset();
                this.existingContactId = null;
              } else {
                let tab = this.lmService.tab_levels.find(el => el.name == 'Lead' && el.data == null);
                // If such a tab exists, find its index and emit a close action
                if (tab) {
                  let index = this.lmService.tab_levels.indexOf(tab);
                  this.isSavedClosed.emit({ level: tab, index: index, isClose: true, lead: this.leadInsertedId });
                }
                this.leadForm.reset();
                this.existingContactId = null;
              }
            }
          }
        },
        error: error => {
          // Enable the save button in case of an error
          this.saveBtnDisable = false;
          const apiError = error?.error || error;
          if (apiError?.fields?.length) {
            this.invalidFields = apiError.fields;
            // Allow ngClass error styles to render before querying the DOM.
            this.focusInvalidFields(100);
          } else {
            this.invalidFields = [];
          }
          let errorArray = ['Not Interested  required', 'No Further Interest required'];
          let errorMessage = errorArray?.includes(error?.message) ? 'Please select a reason for no further interest before saving.' : error?.message;
          this.toaster.error(errorMessage);
        },
      });
    }
  }

  invalidFields: string[] = [];
  isFieldInvalid(fieldName: string): boolean {
    return this.invalidFields?.includes(fieldName);
  }

  // p-inputSwitch pulls focus onto its own checkbox when toggled, which blurs the
  // ng-select search box in the dropdown header. Hand focus back after the toggle.
  refocusSelectSearch(select: NgSelectComponent): void {
    setTimeout(() => select?.searchInput?.nativeElement?.focus());
  }

  // Selector matching every error-highlight class used across the add-lead form.
  private readonly invalidFieldSelector = '._input-error, .invalidField, .is-invalid, .invalidCalendarField';

  /**
   * After the add/update API reports required/invalid fields, scroll the first
   * highlighted field into view so the user can see what needs attention.
   * Works on the standalone Leads page and when the form is embedded in a nested
   * sidebar (project / listing / task / contact pages), where the scroll lives in
   * an inner container that native scrollIntoView does not reliably move.
   */
  private focusInvalidFields(renderDelayMs = 0): void {
    if (!this.invalidFields?.length) return;

    // Wait for ngClass error styles to apply before querying the DOM.
    setTimeout(() => {
      const host = this.hostEl.nativeElement as HTMLElement;
      // Prefer fields inside this component; fall back to the document in case the
      // form is rendered through an overlay/dialog outside the component host.
      let invalidEls = Array.from(host.querySelectorAll(this.invalidFieldSelector)) as HTMLElement[];
      if (!invalidEls.length) {
        invalidEls = Array.from(document.querySelectorAll(this.invalidFieldSelector)) as HTMLElement[];
      }
      // Skip fields hidden by display:none / detached sections.
      const target = invalidEls.find(el => el.getClientRects().length > 0);
      if (target) this.scrollFieldIntoView(target);
    }, renderDelayMs);
  }

  /**
   * Scroll every scrollable ancestor (inner-most first) so the field is centered.
   * Native scrollIntoView misses the inner sidebar scroller on embedded pages, so
   * we walk the ancestor chain explicitly, then finish with the window scroller.
   */
  private scrollFieldIntoView(target: HTMLElement): void {
    let el = target.parentElement;
    while (el && el !== document.body && el !== document.documentElement) {
      const style = getComputedStyle(el);
      const canScroll = /(auto|scroll|overlay)/.test(style.overflowY + style.overflow) && el.scrollHeight > el.clientHeight;
      if (canScroll) {
        const containerRect = el.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        // Instant scroll keeps the rect math correct for the next ancestor up.
        el.scrollTop += targetRect.top - containerRect.top - (el.clientHeight - targetRect.height) / 2;
      }
      el = el.parentElement;
    }
    // Center within the page/window scroller too.
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  contactConflict: boolean = false;
  contactList: any = [];
  duplicateContactDraft: DuplicateContactDraft = {};

  convertToContact(leadId, contact_id = null, create_new = false, add_as_alternate = false, alternate_label: string = null) {
    this.contactConflict = false;

    let payload = {
      contactid: contact_id,
      createnew: create_new,
      add_as_alternate,
      alternate_label,
    };

    this.leads.convertLeadToContact(leadId, payload).subscribe({
      next: response => {
        if (response.hasOwnProperty('userexist') || response.hasOwnProperty('usersexist')) {
          this.contactList = response.userexist ?? response.usersexist;
          this.duplicateContactDraft = {
            firstName: this.leadForm.controls['first_name'].value,
            lastName: this.leadForm.controls['last_name'].value,
            fullName: this.leadForm.controls['full_name'].value,
            email: this.leadForm.controls['email'].value,
            mobile: this.leadForm.controls['mobile_phone'].value,
          };
          this.contactConflict = true;
        } else {
          if (response.message == 'Email is required.') {
            this.toaster.error(response.message);
          } else {
            this.toaster.success(response.message);
            if (this.embedded) {
              this.emitLeadClosed();
              this.leadForm.reset();
            } else {
              let tab = this.lmService.tab_levels.find(el => el.name == 'Lead' && el.data == null);
              // If such a tab exists, find its index and emit a close action
              if (tab) {
                let index = this.lmService.tab_levels.indexOf(tab);
                this.isSavedClosed.emit({ level: tab, index: index, isClose: true, lead: this.leadInsertedId });
                this.leadForm.reset();
              }
            }
          }
        }
      },
    });
  }
}
